// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';

// Component
import SpeakToAdvisorPage from './SpeakToAdvisorPage';

// Selectors
import { getTransportationOption } from 'store/reducers/appointment/selectors';
import { getSelfCheckInFlow } from 'store/reducers/selfCheckIn/selectors';

const mapStateToProps = state => ({
  transportationOption: getTransportationOption(state),
  selfCheckInFlow: getSelfCheckInFlow(state)
});

export default compose(
  withRouter,
  connect(mapStateToProps)
)(SpeakToAdvisorPage);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/SpeakToAdvisorPage/SpeakToAdvisorPageContainer.js